import { render, staticRenderFns } from "./DiscussionList.vue?vue&type=template&id=6e353ae3&scoped=true&"
import script from "./DiscussionList.vue?vue&type=script&lang=js&"
export * from "./DiscussionList.vue?vue&type=script&lang=js&"
import style0 from "./DiscussionList.vue?vue&type=style&index=0&id=6e353ae3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e353ae3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/kreston-is.sdev.cz/httpdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e353ae3')) {
      api.createRecord('6e353ae3', component.options)
    } else {
      api.reload('6e353ae3', component.options)
    }
    module.hot.accept("./DiscussionList.vue?vue&type=template&id=6e353ae3&scoped=true&", function () {
      api.rerender('6e353ae3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/parts/discussion/DiscussionList.vue"
export default component.exports